import { Property } from '../api/entities/property';

export function getPropertyName(property?: Property) {
  return property?.name ?? 'Unknown property';
}
